import { FilterFilled } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import React from 'react';
import { useTranslation } from 'react-i18next';

type OpenClassViewInstructionsProps = {
  visible: boolean;
  onCancel?: () => void;
};

const OpenClassViewInstructions: React.FC<OpenClassViewInstructionsProps> = ({
  visible,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      footer={null}
      maskClosable={false}
      open={visible}
      title={t('components.OpenClassViewInstructions.instructions')}
      onCancel={onCancel}>
      <h3>{t('components.OpenClassViewInstructions.filter')}</h3>
      <Paragraph>
        {t('components.OpenClassViewInstructions.filterInstructions.1')}{' '}
        <Button
          icon={<FilterFilled style={{ fontSize: '14px' }} />}
          shape="circle"
          size="small"
          type="primary"
        />{' '}
        {t('components.OpenClassViewInstructions.filterInstructions.2')}
      </Paragraph>
      <h3>{t('components.OpenClassViewInstructions.calendar')}</h3>
      <Paragraph>
        {t('components.OpenClassViewInstructions.calendarInstructions.1')}{' '}
        {t('components.OpenClassViewInstructions.calendarInstructions.2')}
      </Paragraph>
      <h3>{t('components.OpenClassViewInstructions.listView')}</h3>
      <Paragraph>
        {t('components.OpenClassViewInstructions.listViewInstructions.1')}{' '}
        {t('components.OpenClassViewInstructions.listViewInstructions.2')}{' '}
        {t('components.OpenClassViewInstructions.listViewInstructions.3')}
      </Paragraph>
    </Modal>
  );
};

export default OpenClassViewInstructions;
